import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfFont from "./../assets/vfs_fonts";
import html2canvas from "html2canvas";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.vfs = pdfFont.pdfMake.vfs;
pdfMake.fonts = {
  MPLUS1p: {
    normal: "MPLUS1p-Regular.ttf",
    bold: "MPLUS1p-Regular.ttf",
    italics: "MPLUS1p-Regular.ttf",
    bolditalics: "MPLUS1p-Regular.ttf",
  },
};
const documentDefinition = {
    pageSize: "A4",
    defaultStyle: {
      font: "MPLUS1p",
      fontSize: 9,
    },
    footer: function (currentPage, pageCount) {
        return {
          text: currentPage.toString() + " / " + pageCount,
          alignment: "center",
        };
  }
}

export const exportSingleDynamicchart = async (id, name) => {
  const element = document.getElementById(id);
  html2canvas(element)
    .then((canvas) => {
        
      // Chuyển đổi canvas thành ảnh (data URL)
      const dataUrl = canvas.toDataURL();
      // Tiếp tục xử lý ảnh, ví dụ: tải xuống hoặc hiển thị
     
        documentDefinition.content = [
          {
            text: `動的レポート - ${name}`,
            fontSize: 18,
            marginBottom: 10,
            alignment: "center",
          },
          {
            columns: [
              {
                width: "100%",
                image: dataUrl,
                fit: [515, 841.89],
              },
            ],
          },
        ]
      pdfMake.createPdf(documentDefinition).download(`動的レポート - ${name}`);
    })
    .catch((error) => {
      console.error("Lỗi khi chuyển đổi ảnh:", error);
    });
};

export const exportMultipleDynamicchart = async (className, name) => {

  const elements = document.getElementsByClassName(`${className}`);
  try {
    const imageUrlsPromise = Array.from(elements).map(async (element, index) => {
      const canvas = await html2canvas(element);
      return canvas.toDataURL();
    });

    const listUrl = await Promise.all(imageUrlsPromise);
   

    const listImagePdf = listUrl.map((url) => ({
      image: url,
      fit: [515, 841.89],
      margin:[0,20,0,0]
    }));
    documentDefinition.content = [ {
        text: `動的レポート - ${name}`,
        fontSize: 15,
        marginBottom: 5,
        alignment: "center",
      },...listImagePdf];
    pdfMake.createPdf(documentDefinition).download(`動的レポート - ${name}`);
  } catch (error) {
    console.error("Lỗi khi chuyển đổi ảnh:", error);
  }
};
export const exportLongImageToPDF = async (elementIds, name) => {
  const pdfWidth = 595; // A4 width in points
  const pdfHeight = 841.89; // A4 height in points
  const margin = 20; // Adjust margin to ensure proper spacing
  let currentHeight = 0;  // Track the current height to determine when to switch pages
  const imagesData = [];  // Array to hold image data for each element

  // Loop through each elementId and capture the image
  for (const elementId of elementIds) {
    const element = document.getElementById(elementId);
    const canvas = await html2canvas(element);
    const imgData = canvas.toDataURL('image/jpeg');

    const imgWidth = canvas.width;
    const imgHeight = (canvas.height * pdfWidth) / imgWidth; // Scale the image height based on the page width

    // If the image doesn't fit, add a page break
    if (currentHeight + imgHeight > pdfHeight) {
      imagesData.push({
        text: "", // Empty space to add a page break
        pageBreak: "after", // Add a page break
      });
      currentHeight = 0; // Reset the height for the new page
    }

    // Add the image data to the PDF content, ensuring margins are respected
    imagesData.push({
      image: imgData,
      fit: [500, imgHeight], // Fit the image to the page width with margin
      margin: [margin, 0, margin, margin], // Margin around the image (top, left, right, bottom)
    });

    currentHeight += imgHeight + margin; // Update current height after adding the image
  }

  // Create the PDF document
  const newDocument = JSON.parse(JSON.stringify(documentDefinition));

  newDocument.content = [
    {
      text: `動的レポート - ${name}`,
      fontSize: 15,
      marginBottom: 5,
      alignment: "center",
      marginTop: -30,
    },
    ...imagesData, // Add all images and page breaks
  ];

  // Set the page size for A4
  newDocument.pageSize = { width: pdfWidth, height: pdfHeight };

  // Create and download the PDF
  const pdfName = `動的レポート - ${name}`;
  pdfMake.createPdf(newDocument).download(pdfName); 
};
